module.exports = __webpack_public_path__ + "img/iguana-tatuada.9f633f14.webp";